import { render, staticRenderFns } from "./Gathering2.vue?vue&type=template&id=0719277f"
import script from "./Gathering2.vue?vue&type=script&lang=js"
export * from "./Gathering2.vue?vue&type=script&lang=js"
import style0 from "./Gathering2.vue?vue&type=style&index=0&id=0719277f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports